// Libs
import React from 'react';
import styled from 'styled-components';
// Hooks
import useTheme from 'hooks/useTheme';
// Components
import IconButton from '@mui/material/IconButton';
import Icon from './Icon';

const Button = styled(IconButton)`
	background-color: transparent !important;
	border-radius: 50% !important;
	transition: background-color 0.15s ease !important;
	& svg {
		transition: transform 0.15s ease, filter 0.15s ease;
	}
	&:hover {
		background-color: rgba(0, 0, 0, 0.18) !important;
	}
	&:hover svg {
		transform: scale(1.15);
		filter: drop-shadow(0 0 1px rgba(255, 255, 255, 0.7));
	}
`;

const EyeIcon = ({ button, onClick, fill }) => {
	const { theme } = useTheme();
	const iconFill = fill ?? theme._mediumEmphasisColor;
	return button ? (
		<Button disableRipple onClick={onClick}>
			<Icon fill={iconFill} />
		</Button>
	) : (
		<Icon fill={iconFill} onClick={onClick} />
	);
};

export default EyeIcon;
